import { studentConstants } from '../actions'

const STUDENT_LANG_KEY = 'studentDashboardLanguageId'

function getSavedLanguageId() {
    try {
        const saved = localStorage.getItem(STUDENT_LANG_KEY)
        if (saved) {
            const parsed = Number(saved)
            if (Number.isFinite(parsed) && parsed > 0) return parsed
        }
    } catch (_) {
        // localStorage may be unavailable
    }
    return 1
}

const initialState = {
    fetchingUserInfo: false,
    userInfo: null,
    userDashboardLanguageId: getSavedLanguageId(),
    selfAccessCode: null,
    isFetchingSelfAccessCode: false,
    isSettingPassword: false,
    passwordSetSuccess: false,
}

export function student(state = initialState, action) {
    switch (action.type) {
        case studentConstants.STUDENT_GET_USER_INFO.REQUEST:
            return {
                ...state,
                fetchingUserInfo: true,
            }
        case studentConstants.STUDENT_GET_USER_INFO.SUCCESS: {
            const serverLangId = action.data?.appLanguageId
            const newLangId = (serverLangId && serverLangId > 0) ? serverLangId : state.userDashboardLanguageId
            if (newLangId !== state.userDashboardLanguageId) {
                try { localStorage.setItem(STUDENT_LANG_KEY, String(newLangId)) } catch (_) {}
            }
            return {
                ...state,
                fetchingUserInfo: false,
                userInfo: action.data,
                userDashboardLanguageId: newLangId,
            }
        }
        case studentConstants.STUDENT_GET_USER_INFO.FAILURE:
            return {
                ...state,
                fetchingUserInfo: false,
            }

        case studentConstants.STUDENT_SET_USER_DASHBOARD_LANGUAGE.REQUEST:
            try { localStorage.setItem(STUDENT_LANG_KEY, String(action.payload.languageId)) } catch (_) {}
            return {
                ...state,
                userDashboardLanguageId: action.payload.languageId,
            }

        case studentConstants.STUDENT_CHANGE_APP_LANGUAGE.REQUEST:
            return {
                ...state,
            }
        case studentConstants.STUDENT_CHANGE_APP_LANGUAGE.SUCCESS:
            return {
                ...state,
            }
        case studentConstants.STUDENT_CHANGE_APP_LANGUAGE.FAILURE:
            return {
                ...state,
            }

        case studentConstants.STUDENT_METADATA.REQUEST:
            return {
                ...state,
            }
        case studentConstants.STUDENT_METADATA.SUCCESS:
            return {
                ...state,
                languages: action.data.languages,
            }
        case studentConstants.STUDENT_METADATA.FAILURE:
            return {
                ...state,
            }

        case studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.REQUEST:
            return {
                ...state,
                isFetchingSelfAccessCode: true,
                selfAccessCode: null,
            }
        case studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.SUCCESS:
            return {
                ...state,
                isFetchingSelfAccessCode: false,
                selfAccessCode: action.data,
            }
        case studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.FAILURE:
            return {
                ...state,
                isFetchingSelfAccessCode: false,
                selfAccessCode: null,
            }

        case studentConstants.STUDENT_SET_PASSWORD.REQUEST:
            return {
                ...state,
                isSettingPassword: true,
                passwordSetSuccess: false,
            }
        case studentConstants.STUDENT_SET_PASSWORD.SUCCESS:
            return {
                ...state,
                isSettingPassword: false,
                passwordSetSuccess: true,
            }
        case studentConstants.STUDENT_SET_PASSWORD.FAILURE:
            return {
                ...state,
                isSettingPassword: false,
                passwordSetSuccess: false,
            }

        default:
            return state
    }
}
